import React, { useState, useEffect } from 'react';
import { Badge, Card, Col, Pagination, Row, Table, Form, Spinner, Button } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faFilePdf, faTrash } from '@fortawesome/free-solid-svg-icons';

import { useTranslation } from "react-i18next";
const GenderCell = ({ claim , genders , setGenders}) => {
      const { t } = useTranslation();
    return (
        <td >
            {claim?._id && (
                <Form.Select
                    value={genders[claim?._id] || ""}
                    onChange={(e) => {
                        const value = e.target.value; // copy before React clears event
                        setGenders(prev => ({
                            ...prev,
                            [claim?._id]: value
                        }));
                    }}
                    size="sm"
                >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                </Form.Select>

            )}

        </td>

    );
};

export default GenderCell;
